import { create } from 'zustand';
import { persist } from 'zustand/middleware';
export const LOCALE_OPTIONS = [
    { code: 'en', label: 'English' },
    { code: 'tr', label: 'Türkçe' },
    { code: 'es', label: 'Español' },
    { code: 'fr', label: 'Français' },
    { code: 'de', label: 'Deutsch' },
    { code: 'ja', label: '日本語' },
];
function applyDocumentLocale(locale) {
    if (typeof document !== 'undefined') {
        document.documentElement.lang = locale;
    }
}
export const useLocaleStore = create()(persist((set) => ({
    locale: 'en',
    setLocale: (locale) => {
        applyDocumentLocale(locale);
        set({ locale });
    },
}), {
    name: 'prototype-locale',
    partialize: (state) => ({ locale: state.locale }),
    onRehydrateStorage: () => (state) => {
        if (state) {
            applyDocumentLocale(state.locale);
        }
    },
}));
